import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, articles } from "@/mocks/articles";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();

  const category = categories.find((c) => c.slug === slug);
  const filteredArticles = articles.filter((a) => a.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen pt-24 pb-14 flex items-center justify-center">
        <p className="text-foreground-500">分类不存在</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            {t("breadcrumb.home")}
          </Link>
          <span>/</span>
          <span className="text-foreground-700">{category.name}</span>
        </nav>

        <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
          {category.name}
        </h1>
        <p className="text-sm text-foreground-500 mb-8">
          共 {category.count} 篇爆料
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filteredArticles.map((article) => (
            <Link
              key={article.id}
              to="/"
              className="group block bg-background-50 rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-500 font-medium">{article.category}</span>
                <h3 className="text-base font-semibold text-foreground-900 mt-1 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400">{article.time}</span>
                  <span className="text-xs text-foreground-400">{article.views.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}